import React from 'react';
import './Logo.css';

const Logo = () => {

  return ( <div className="logo">
    <div className="outer-circle">
      <div className="floating-circle"/>
      <div className="inner-circle"/>
    </div>
  </div> )
}

export default Logo;


// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js